import React from 'react';
import { Linkedin, Twitter, Github, Mail } from 'lucide-react';
import { siteConfig } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800/50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img 
                src={siteConfig.logoUrl} 
                alt={siteConfig.companyName}
                className="h-16 w-auto"
              />
            </div>
            <p className="text-slate-400 leading-relaxed mb-4 max-w-md">
              Delivering cutting-edge AI solutions that empower businesses and transform operations globally. Innovation meets excellence.
            </p>
            <p className="text-blue-400 text-sm mb-6">
              www.enovaaitechnologies.co.uk
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-slate-800/50 hover:bg-blue-500/20 border border-slate-700/50 hover:border-blue-500/50 flex items-center justify-center transition-all duration-300 group"
              >
                <Linkedin className="w-5 h-5 text-slate-400 group-hover:text-blue-400 transition-colors" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-slate-800/50 hover:bg-blue-500/20 border border-slate-700/50 hover:border-blue-500/50 flex items-center justify-center transition-all duration-300 group"
              >
                <Twitter className="w-5 h-5 text-slate-400 group-hover:text-blue-400 transition-colors" />
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-slate-800/50 hover:bg-blue-500/20 border border-slate-700/50 hover:border-blue-500/50 flex items-center justify-center transition-all duration-300 group"
              >
                <Github className="w-5 h-5 text-slate-400 group-hover:text-blue-400 transition-colors" />
              </a>
              <a
                href="mailto:Info@enovaaitechnologies.co.uk"
                className="w-10 h-10 rounded-lg bg-slate-800/50 hover:bg-blue-500/20 border border-slate-700/50 hover:border-blue-500/50 flex items-center justify-center transition-all duration-300 group"
              >
                <Mail className="w-5 h-5 text-slate-400 group-hover:text-blue-400 transition-colors" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Solutions', 'Portfolio', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-slate-400 hover:text-blue-400 transition-colors duration-200 text-left"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              {[
                'AI Automation',
                'Predictive Analytics',
                'NLP Solutions',
                'Cloud Infrastructure',
                'API Development'
              ].map((service) => (
                <li key={service}>
                  <button
                    onClick={() => scrollToSection('solutions')}
                    className="text-slate-400 hover:text-blue-400 transition-colors duration-200 text-left"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800/50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} EnovaAI Technologies. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <button
                onClick={() => scrollToSection('contact')}
                className="text-slate-400 hover:text-blue-400 transition-colors duration-200 text-sm"
              >
                Privacy Policy
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-slate-400 hover:text-blue-400 transition-colors duration-200 text-sm"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
